import { BatchesCollection, SelectedBatches, TriState } from './typings';

export function getSelectedBatches(collection: BatchesCollection): SelectedBatches {
    return collection.batches
        .filter(batch => batch.selected !== TriState.FALSE)
        .map(batch => {
            return {
                id: batch.id,
                creativeIds: batch.items.filter(item => item.selected).map(item => item.id)
            };
        });
}
